import PropTypes from 'prop-types';
import { assetUrl, cn } from '@Shared/Helpers/Utilities';
import { useEffect } from 'react';

const collections = [];

const BaseSvgSprite = ({
    className = null,
    testid,
    prefix,
    collectionName,
    iconId,
    ...rest
}) => {
    const collection = `${prefix}-${collectionName}`;
    const url = assetUrl(`/assets/images/svg/${prefix}/${collectionName}.svg`);

    useEffect(() => {
        if (collections.indexOf(collection) === -1) {
            collections.push(collection);

            fetch(url)
                .then((res) => res.text())
                .then((svg) => {
                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = svg;

                    const elementsWithId = wrapper.querySelectorAll('[id]');
                    elementsWithId.forEach((el) => {
                        el.id = `${collection}-${el.id}`;
                    });

                    const svgs = wrapper.querySelectorAll('svg');
                    svgs.forEach((el) => {
                        el.id = collection;
                        el.style.display = 'none';
                    });

                    document.body.appendChild(wrapper.firstChild);
                });
        }
    }, []);

    return (
        <svg data-testid={testid} className={cn([className])} {...rest}>
            <use xlinkHref={`#${collection}-${iconId}`} />
        </svg>
    );
};

BaseSvgSprite.propTypes = {
    testid: PropTypes.string.isRequired,
    iconId: PropTypes.string.isRequired,
    collectionName: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default BaseSvgSprite;
